import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import analytics from "../utils/analytics";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Header from "../components/Header";
import FooterComponent from "../components/Footer";
import { setUserResult } from "../redux/action/result";

function HomePage() {
  const dispatch = useDispatch();
  const CalculateButtonValue = useFeatureFlag("Calculate_Button_text");
  const HomeMainTitle = useFeatureFlag("Home_Page_Main_Title");
  const HomePageDescription = useFeatureFlag("Home_Page_Description");
  const Referrals_mandatory_sentance = useFeatureFlag("_referrals_mandatory");
  useEffect(() => {
    dispatch(setUserResult(""));
  }, []);

  const navigate = useNavigate();
  const competencies = [
    "Technical skills",
    "Design and architecture",
    "Management and leadership",
    "Creativity and innovation",
    "Industry-specific expertise",
    "Interpersonal communication",
    "Process optimization",
    "Quality Assurance",
    "Product design and development",
    "Network Management and security",
    "Digitalization and Cloud computing",
    "AI and Machine learning",
    "IoT",
  ];

  return (
    <React.Fragment>
      <Header />
      <Container maxWidth="xl" component="main" sx={{ p: 4 }}>
        <Grid container rowSpacing={1} sx={{ alignItems: "center" }}>
          <Grid
            item
            xs={12}
            sm={5}
            order={{ xs: 1, sm: 1 }}
            justifyContent={{ xs: "center", md: "left", lg: "left" }}
          >
            <Grid
              display={"flex"}
              alignItems="center"
              justifyContent={"flex-start"}
              sx={{ pb: 5 }}
              pt={{ xs: 5, md: 0, lg: 0 }}
              order={{ xs: 3, sm: 3, lg: 1 }}
              item
            >
              <img
                src={"../../assets/images/india-flag.png"}
                style={{ minWidth: "60px" }}
                alt="india-flag"
                loading="lazy"
              />
              <Typography component="p" variant="h5" gutterBottom sx={{ pl: 3, mb: 0 }}>
                For Indian Tech / Software Personnel
              </Typography>
            </Grid>
            <Grid
              item
              order={{ xs: 1, sm: 1, lg: 2 }}
              justifyContent={{ xs: "center", md: "left", lg: "left" }}
            >
              <Typography
                sx={{ fontWeight: 700 }}
                textAlign={{ xs: "center", lg: "left", md: "left" }}
                component="h1"
                variant="h2"
                gutterBottom
              >
                {HomeMainTitle}
              </Typography>
            </Grid>
            <Grid
              item
              order={{ xs: 3, sm: 3, lg: 2 }}
              display={{ xs: "none", md: "block", lg: "block" }}
            >
              <Typography component="h4" variant="h4">
                {HomePageDescription}
              </Typography>
            </Grid>
            <Grid
              item
              order={{ xs: 2, sm: 2 }}
              display={"flex"}
              alignItems={{
                xs: "center",
                sm: "flex-start",
                md: "flex-start",
                lg: "flex-start",
              }}
              flexDirection={"column"}
              justifyContent={{
                xs: "center",
                md: "left",
                lg: "flex-start",
                xl: "left",
              }}
              textAlign={{
                xs: "center",
                sm: "center",
                md: "left",
                lg: "left",
              }}
            >
              {Referrals_mandatory_sentance ? (
                <Typography sx={{ mt: "10px", mb: "10px" }}>
                  Be ready with 3 referrrals prior to clicking "Calculate your worth" - You may have
                  to provide references to validate your expertise.
                </Typography>
              ) : null}

              <Button
                sx={{ mt: "10px", mb: "20px" }}
                variant="contained"
                onClick={() => {
                  analytics.trackClickCTA("calculate_salary", "hero_section");

                  navigate("/skills-calculation");
                }}
              >
                {CalculateButtonValue}
              </Button>
            </Grid>

            <Grid item order={{ xs: 4, sm: 4, lg: 4 }}>
              <Typography
                variant="body1"
                component="p"
                textAlign={{ xs: "center", lg: "left", md: "left" }}
              >
                TrueSelfy’s innovative algorithm offers comprehensive evaluation of{" "}
                <mark>5000+ </mark>
                technology skills,<mark> 750+</mark> technology management skills,{" "}
                <mark>1000+</mark> functional/domain skills, and <mark>30000+</mark> generic skills
                to determine the current market value of your expertise. TrueSelfy considers
                macroeconomic impact, technological advancements and obsolescence, and is
                continuously updated with new competencies so that the insights you get are always
                current.
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={7} order={{ xs: 2, sm: 2 }}>
            <Box>
              <img width={"100%"} src={`../../assets/images/Pizza-Home-1.svg`} alt="pizza" loading="lazy" />
            </Box>
          </Grid>
          <Grid
            item
            order={{ xs: 3, sm: 3, lg: 2 }}
            display={{ xs: "block", md: "none", lg: "none" }}
          >
            <Typography component="h4" variant="h4" textAlign={"center"}>
              It's now possible to access precise, up-to-date, unbiased and objective salary
              information for numerous professions, Thanks to innovative technology! With the aid of
              TrueSelfy's advanced and comprehensive TechWorth algorithm, you can assess the current
              market value of your technological expertise.
            </Typography>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="xl" component="main">
        <Grid container sx={{ display: "flex", justifyContent: "center" }}>
          <Box sx={{ textAlign: "center" }} mb={{ xs: 2, md: 2, lg: 5 }}>
            <Typography
              sx={{ fontWeight: 700 }}
              component="h3"
              variant="h3"
              gutterBottom
              textAlign={{ xs: "left", md: "left", lg: "center" }}
            >
              TrueSelfy is designed for all types of competencies
            </Typography>
          </Box>
        </Grid>
        <Grid
          container
          spacing={1.5}
          sx={{ mb: 5 }}
          pl={{ xs: 0, md: 0, lg: 7 }}
          textAlign={{ xs: "center", md: "center", lg: "left" }}
          // alignItems="center"
          display="flex"
          justifyContent={"center"}
        >
          {competencies?.map((item, index) => (
            <Grid
              item
              xs={12}
              lg={4}
              md={4}
              display="flex"
              justifyContent={{ xs: "left", md: "left", lg: "left" }}
              alignItems={"center"}
              key={index}
            >
              <CheckCircleIcon
                sx={{
                  color: "#2BB344",
                  mr: 0.5,
                }}
              />
              <Typography
                size="large"
                variant="h5"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {item}
              </Typography>
            </Grid>
          ))}
        </Grid>
        <FooterComponent />
      </Container>
    </React.Fragment>
  );
}

export default HomePage;
